import React from "react";
import Carousel from "react-slick";
import withStyles from "@material-ui/core/styles/withStyles";

import GridContainer from "../../../components/Grid/GridContainer.jsx";
import GridItem from "../../../components/Grid/GridItem.jsx";
import Card from "../../../components/Card/Card.jsx";

import carouselStyle from "../../../assets/jss/material-kit-pro-react/views/componentsSections/carouselStyle.jsx";
import logoGobColombia from "../../../assets/img/sponsorsLogos/logo-gobierno-de-colombia.png"
import logoMinTIC from "../../../assets/img/sponsorsLogos/logo-ministerio-tic.png"
import logoAppsCo from "../../../assets/img/sponsorsLogos/logo-appsco.png"
import logoAppsCoUnab from "../../../assets/img/sponsorsLogos/logo-appsco-unab.png"
import logoBoyParaVivirla from "../../../assets/img/sponsorsLogos/logo-boyaca-es-para-vivirla.png"
import logoCComercio from "../../../assets/img/sponsorsLogos/logo-camara-comercio-tunja.png"
import logoFonEmprender from "../../../assets/img/sponsorsLogos/logo-fondo-emprender.png"
import logoFonade from "../../../assets/img/sponsorsLogos/logo-fonade.png"
import logoColciencias from "../../../assets/img/sponsorsLogos/logo-colciencias.png"
import logoSecTIC from "../../../assets/img/sponsorsLogos/logo-secretaría-productividad-tic.png"
import logoSena from "../../../assets/img/sponsorsLogos/logo-sena.png"
import logoUniboyaca from "../../../assets/img/sponsorsLogos/logo-uniboyaca.png"
import logoWesearch from "../../../assets/img/sponsorsLogos/logo-we-search.png"
import logoViveLab from "../../../assets/img/sponsorsLogos/logo-vivelab-boyaca.png"

class SectionCarousel extends React.Component {
    render() {
        const { classes } = this.props;
        const settings = {
            dots: false,
            infinite: true,
            speed: 1000,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true
        };
        return (
            <div>
                <div>
                    <GridContainer>
                        <GridItem xs={8} sm={8} md={8} className={classes.marginAuto}>
                            <Card className={classes.noPaddingTop}>
                                <Carousel {...settings}>
                                    <div>
                                        <a href="https://id.presidencia.gov.co" target="_blank" rel="external nofollow noopener noreferrer">
                                            <img
                                                src={logoGobColombia}
                                                className="slick-image"
                                                alt="Gobierno Colombia"
                                                title="Gobierno de Colombia"
                                            />
                                        </a>
                                    </div>
                                    <div>
                                        <a href="https://www.mintic.gov.co" target="_blank" rel="external nofollow noopener noreferrer">
                                            <img
                                                src={logoMinTIC}
                                                className="slick-image"
                                                alt="Ministerio TIC"
                                                title="Ministerio de las TIC"
                                            />
                                        </a>
                                    </div>
                                    <div>
                                        <a href="https://apps.co" target='_blank' rel="external nofollow noopener noreferrer">
                                            <img
                                                src={logoAppsCo}
                                                className="slick-image"
                                                alt="AppsCo"
                                                title="AppsCo"
                                            />
                                        </a>
                                    </div>
                                    <div>
                                        <img
                                            src={logoAppsCoUnab}
                                            className="slick-image"
                                            alt="AppsCo Unab"
                                            title="AppsCo Unab"
                                        />
                                    </div>
                                    <div>
                                        <img
                                            src={logoBoyParaVivirla}
                                            className="slick-image"
                                            alt="Boyacá es para vivirla"
                                            title="Boyacá es para vivirla"
                                        />
                                    </div>
                                    <div>
                                        <a href="https://ccomerciotunja.org.co" target='_blank' rel="external nofollow noopener noreferrer">
                                            <img
                                                src={logoCComercio}
                                                className="slick-image"
                                                alt="Camara de Comercio de Tunja"
                                                title="Camara de Comercio de Tunja"
                                            />
                                        </a>
                                    </div>
                                    <div>
                                        <a href="http://www.fondoemprender.com" target='_blank' rel="external nofollow noopener noreferrer">
                                            <img
                                                src={logoFonEmprender}
                                                className="slick-image"
                                                alt="Fondo Emprender"
                                                title="Fondo Emprender"
                                            />
                                        </a>
                                    </div>
                                    <div>
                                        <a href="http://www.fonade.gov.co" target='_blank' rel="external nofollow noopener noreferrer">
                                            <img
                                                src={logoFonade}
                                                className="slick-image"
                                                alt="Fonade"
                                                title="Fonade"
                                            />
                                        </a>
                                    </div>
                                    <div>
                                        <a href="http://www.colciencias.gov.co" target='_blank' rel="external nofollow noopener noreferrer">
                                            <img
                                                src={logoColciencias}
                                                className="slick-image"
                                                alt="Colciencias"
                                                title="Colciencias"
                                            />
                                        </a>
                                    </div>
                                    <div>
                                        <a href="http://www.boyaca.gov.co" target='_blank' rel="external nofollow noopener noreferrer">
                                            <img
                                                src={logoSecTIC}
                                                className="slick-image"
                                                alt="Secretaria Productividad TIC Gobernacion Boyaca"
                                                title="Secretaria Productividad TIC Gobernacion Boyaca"
                                            />
                                        </a>
                                    </div>
                                    <div>
                                        <a href="http://www.sena.edu.co/" target='_blank' rel="external nofollow noopener noreferrer">
                                            <img
                                                src={logoSena}
                                                className="slick-image"
                                                alt="Servicio Nacional de Aprendizaje SENA"
                                                title="Servicio Nacional de Aprendizaje SENA"
                                            />
                                        </a>
                                    </div>
                                    <div>
                                        <a href="https://www.uniboyaca.edu.co/" target='_blank' rel="external nofollow noopener noreferrer">
                                            <img
                                                src={logoUniboyaca}
                                                className="slick-image"
                                                alt="Universidad de Boyaca"
                                                title="Universidad de Boyaca"
                                            />
                                        </a>
                                    </div>
                                    <div>
                                        <img
                                            src={logoWesearch}
                                            className="slick-image"
                                            alt="We Search Red Comercial"
                                            title="We Search Red Comercial"
                                        />
                                    </div>
                                    <div>
                                        <a href="https://twitter.com/vivelabboyaca" target='_blank' rel="external nofollow noopener noreferrer">
                                            <img
                                                src={logoViveLab}
                                                className="slick-image"
                                                alt="ViveLab Boyaca"
                                                title="ViveLab Boyaca"
                                            />
                                        </a>
                                    </div>
                                </Carousel>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </div>
            </div>
        );
    }
}

export default withStyles(carouselStyle)(SectionCarousel);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/SponsorsCarouselSection.jsx